import type { EventData } from '../types/index';
import type { PsHttpSSE } from '@patsnap-utils/sse';
import { FactoryPsHttpSSE } from '@patsnap-utils/sse';
import {
    PsHttpService,
    type PatSnapCommonResponseData,
} from '@patsnap/tahiti-core/common/ps-http';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';

export interface AiSearchFilter {
    resource?: string[]; // 数据源
    year?: [number, number]; // 发表时间(年)
    legal_status?: string[]; // 方案成熟度: ["verified", "new", "free"]
    country?: { name: string; include: boolean }; // 国家与地区
    company?: { name: string; include: boolean }; // 竞争对手
}

export interface AiSearchJobRequest {
    initial_message?: string;
    conversation_id?: string;
    filter?: AiSearchFilter;
}

export interface AiSearchJobResponse {
    session_id: string;
    conversation_id: string;
}

export interface SendSearchMessageRequest {
    conversation_id: string;
    append_message: string;
}

export interface ConfirmSearchRequest {
    confirm_type: string;
    remark: string;
}

export interface AiSearchApi {
    createAiSearchJob(data: AiSearchJobRequest): Promise<AiSearchJobResponse>;
    getJobStream(data: {
        conversation_id: string;
        session_id?: string;
    }): PsHttpSSE<EventData>;
}

export const AiSearchApi = Symbol('AiSearchApi');

@injectable()
export class AiSearchApiImpl extends PsHttpService implements AiSearchApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/api/research`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    /**
     * 创建一个AI搜索任务
     */
    createAiSearchJob(data: AiSearchJobRequest) {
        return this.post<PatSnapCommonResponseData<AiSearchJobResponse>>({
            url: `${this.options.baseURL}/sessions`,
            data,
        }).then((res) => {
            return res.data as AiSearchJobResponse;
        });
    }

    @inject(FactoryPsHttpSSE)
    private _factorySsePsHttp!: FactoryPsHttpSSE;

    /**
     * 获取任务的流
     */
    getJobStream(data: {
        conversation_id: string;
        session_id?: string;
    }) {
        return this._factorySsePsHttp<EventData>()
            .init({
                url: `${this.options.baseURL}/conversations/${data.conversation_id}/stream`,
                data,
                hasFinalMessage: () => true,
            });
    }
}
